/**
 * LayoutsPanel component
 * @constructor editor.mediatabs.LayoutsPanel
 * @param {object} dom DOM
 */
fx.ns("desktop.common.panels", class LayoutsPanel extends fx.components.Box
{
    
    constructor(model, filter, options)
	{
		super(model);

		this.layouts = model.layouts;
        this._creation = model.creation;
        this.layoutFilter = filter;

        this._options = Object.assign(this.defaults, options || {});

		this.listenUpdates(model.creation);
		
	}

    get defaults()
    {
        return { 
                    maxElementsPerRow : (fx.get("app") == "calendar" && this.data.creation.shape_option == "landscape") ? 1 : 2,
                    maxRowHeight : 160,
                    newChildEffect : "fade" 
                };
    }

    get options()
	{
		return this._options;
	}


	get creation()
	{
		return this._creation;
	}

	set creation(val)
	{
		this._creation = val;
	}
	
	get currentArea()
	{
		return this._currentArea;
	}

	set currentArea(val)
	{
		this._currentArea = val;

        // TODO : check if needed
		if (this.layoutFilter)
			this.layoutFilter.area = this._currentArea;

	}

	create()
	{
		super.create();

		//--------------------- layouts ---------------------//

        if (!this.layoutFilter)
		    this.layoutFilter = new filters.LayoutThemeFilter( this.creation.themeid, this.data.choosedThemeTag, this.data.themes, "recommended" );

		this.layoutFilter.search = "";

		
		this.layoutsGrid = new fx.components.VerticalGridDynamic( { className : "layoutGrid",
																	data : this.layouts,
																	filter : this.layoutFilter,
																	maxElementsPerRow : this.options.maxElementsPerRow,
																	maxRowHeight : this.options.maxRowHeight,
																	newChildEffect : this.options.newChildEffect,
																	renderers : {ThemeLayout : shared.renderers.LayoutRenderer} 
																} );
                                                                
		this.addChild( new fx.components.Text({className : "coverTitle", text : fx.text("Mises en pages")}), {width : "100%",height : 20, top : 20, left : 0});
		this.addChild(this.layoutsGrid, {height:"fill", width:"100%", top : 50});
		


	}

	/****** Events ******/


	/****** Functions ******/

});
